module.exports = __webpack_public_path__ + "img/baggage.bf0f50f5.svg";